import React, { useState } from 'react';
import { connect } from 'react-redux';
import { EaseModal } from '../../../libs/EaseModal';
import { QuickTransferForm } from '../Forms';
import { Text1 } from '../../../styles';
import { alertify, handleApiExceptions } from '../../../app_methods';
import { Beneficiary, QuickTransfer } from '../../../models';
import { OTPModal } from '../OTPModal';
import { MerchantService } from '../../../services';
import { updateCurrentUserAction } from '../../../redux/actions';

const quickTransfer = new QuickTransfer();

const QuickTransferModalComponent = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isVerifying, setIsVerifying] = useState(false);
    const [showOTPModal, setShowOTPModal] = useState(false);
    const [isBankOTP, setIsBankOTP] = useState(false);
    const [otpRefKey, setOtpRefKey] = useState('');
    const virtual_accounts = props.current_user.virtual_accounts ?? []
    const [virtual_account, setVirtual_account] = useState(virtual_accounts.find((va) => va.virtual_account_number === quickTransfer.virtual_account_number) || {})
    const [isBeneType, setIsBeneType] = useState("")
    const [isCreating, setIsCreating] = useState(false);

    const validateQuickTransfer = async () => {
        setIsLoading(true);
        let va = virtual_accounts.find((va) => va.virtual_account_number === quickTransfer.virtual_account_number)
        const response = await quickTransfer.validate();
        if (!response.success) {
            setIsLoading(false);
            if (response.error_code == 'TR_E001') {
                alertify("Oops!!!", response.message, "confirm", { closable: true, onOk: () => generateTransferOTP("beneficiary", va), onCancel: () => { } });
            } else {
                handleApiExceptions(response)
            }
            return;
        }
        setIsLoading(false);
        if (props?.current_user?.merchant_active_on_sbi) {
            generateTransferOTP("transfer", va);
            return;
        }
        if (props.current_user.bpo) {
            initiateQuickTransfer();
            return;
        }
        generateTransferOTP("transfer", va);
    };

    const generateTransferOTP = async (type = "transfer", virtual_accountParam) => {
        const va = virtual_accountParam || virtual_account;
        setIsBeneType(type);
        setIsLoading(true);
        let queryData = {
            type,
            send_email: true,
            send_sms: true,
            amount: quickTransfer.amount,
            payment_mode: quickTransfer.payment_mode,
            beneficiary_name: quickTransfer.beneficiary_name,
        };

        if (props?.current_user?.merchant_active_on_sbi) {
            queryData.provider_code = va?.provider_code;
            queryData.beneficiary_account_number = quickTransfer?.account_number;
            queryData.beneficiary_ifsc = quickTransfer?.ifsc;
        }

        try {
            let response;
            if (props?.current_user?.merchant_active_on_sbi) {
                queryData.provider_code = queryData.provider_code || "SBI";
                response = await MerchantService.generate_bank_otp(queryData);
            } else {
                response = await MerchantService.generate_otp(queryData);
            }

            if (response.success) {
                setShowOTPModal(true);
                if (props?.current_user?.merchant_active_on_sbi) {
                    setIsBankOTP(true);
                    setOtpRefKey(response.otp_ref_key);
                }
            } else {
                handleApiExceptions(response.success ? "OTP generation failed." : response);
            }
        } catch (error) {
            handleApiExceptions({ success: false, status: error?.response?.status || 400 });
        } finally {
            setIsLoading(false);
        }
    };

    const saveBeneficiary = async (values) => {
        setIsCreating(true);
        const beneficiary = new Beneficiary(values);
        const response = await beneficiary.save();
        if (!response.success) {
            setIsCreating(false);
            handleApiExceptions(response);
            return;
        }
        alertify("Success", "Beneficiary created successfully.", "success");
        setIsCreating(false);
    };

    const verifyOTP = (otp) => {
        setIsVerifying(true);
        if (!props?.current_user?.merchant_active_on_sbi) {
            MerchantService.verify_otp({ otp }).then((response) => {
                if (response.success) {
                    if (response.data.verified) {
                        toggleOTPModal();
                        initiateQuickTransfer();
                    }
                    else handleApiExceptions("OTP is incorrect.");
                }
                else handleApiExceptions("OTP verification failed.");
                setIsVerifying(false);
            }).catch((error) => {
                setIsVerifying(false);
                handleApiExceptions({ success: false, status: (error.response && error.response.status) || 400 });
            });
        } else {
            let otp_details = { 'otp': otp, 'otp_ref_key': otpRefKey }
            quickTransfer.otp_details = otp_details
            setIsVerifying(false);
            toggleOTPModal();
            if (isBeneType == "transfer") {
                initiateQuickTransfer();
            }
            else {
                props.toggleTransferModal();
                saveBeneficiary(quickTransfer)
            }
        }

    };

    const initiateQuickTransfer = async () => {
        setIsLoading(true);
        const response = await quickTransfer.initiate();
        if (!response.success) {
            setIsLoading(false);
            handleApiExceptions(response);
            return;
        }
        alertify("Success", response.data.message, "success");
        props.toggleTransferModal();
        setIsLoading(false);
        props.onSuccess();
        fetchMerchantInfo();
        quickTransfer.reset();
    };

    const toggleOTPModal = () => {
        setShowOTPModal(!showOTPModal);
    };

    const fetchMerchantInfo = () => {
        MerchantService.fetch().then((response) => {
            if (response.success) props.updateCurrentUser(response.data.merchant);
        });
    };

    return (
        <EaseModal
            width={550}
            title={false}
            visible={props.visible}
            onCancel={props.toggleTransferModal}
            centered
            hideFooter
            destroyOnClose
        >
            <Text1 className="d-block mb-4" strong>Instant Transfer</Text1>
            <QuickTransferForm
                onSubmit={(values) => {
                    quickTransfer.set(values);
                    validateQuickTransfer();
                }}
                loading={isLoading}
                submitText="Transfer"
            />
            <OTPModal
                visible={showOTPModal}
                onCancel={toggleOTPModal}
                verifyOTP={verifyOTP}
                loading={isVerifying}
                generateOTP={()=>generateTransferOTP(isBeneType)}
                isBankOTP={isBankOTP}
            />
        </EaseModal>
    )
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
})

const mapDispatchToProps = dispatch => ({
    updateCurrentUser: user => dispatch(updateCurrentUserAction(user))
})

const QuickTransferModal = connect(mapStateToProps, mapDispatchToProps)(QuickTransferModalComponent);


export { QuickTransferModal };